export const API_ENDPOINT = 'https://interni-api.euroexpress.ba';
// export const API_ENDPOINT = 'http://localhost:14726';
